/* eslint-disable import/no-cycle */
import { checkTokenValidity } from '@/helpers/token'
import store from '@/store'

/**
 * Return if user is logged in
 * This is completely up to you and how you want to store the token in your frontend application
 * e.g. If you are using cookies to store the application please update this function
 */
export const isUserLoggedIn = () => {
  const user = store.getters['auth/getCurrentUser']
  const token = store.getters['auth/getToken']
  const refreshToken = store.getters['auth/getRefreshToken']

  if (user && token !== null && refreshToken !== null) {
    return checkTokenValidity(token)
  }

  return false
}

export const getUserData = () => store.getters['auth/getCurrentUser']

/**
 * This function is used for demo purpose route navigation
 * In real app you won't need this function because your app will navigate to same route for each users regardless of ability
 * Please note role field is just for showing purpose it's not used by anything in frontend
 * We are checking role just for ease
 * NOTE: If you have different pages to navigate based on user ability then this function can be useful. However, you need to update it.
 * @param {String} userRole Role of user
 */
export const getHomeRouteForLoggedInUser = userRole => {
  if (userRole) return '/'
  return { name: 'auth-login' }
}

export const hasForcedChangeOfPassword = () => store.getters['auth/getHasForcedChangeOfPassword']
